/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC} from 'react'
import {Routes, Route, BrowserRouter, Navigate,} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {ContactUsPage, DownloadAppPage} from '../modules/landing/LandingPage'
import {Logout, AuthPage, useAuth} from '../modules/auth'
import {App} from '../App'
import Index from '../modules/ticket/support/Index'
import { GoogleLogin } from '../modules/auth/components/externals/GoogleLogin'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  const {currentUser} = useAuth()
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='contact-us' element={<ContactUsPage />} />    
          <Route path='support/*' element={<Index />} />          
          <Route path='error/*' element={<ErrorsPage />} />           
          <Route path='download/*' element={<DownloadAppPage />} />
          <Route path='logout' element={<Logout />} />
          <Route path='/' element={<Navigate to='/dashboard' />} />
          {currentUser ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/dashboard' />} /> 
              
            </>
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='/auth/externals/login' element={<GoogleLogin />} />
              <Route path='*' element={<Navigate to='/auth' />} />
			        {/* <Route path='auth/*' element={<Navigate to='/auth' />} /> */}
              {/* <Route path='*' element={<Navigate to='/' />} /> */}
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
